import React from "react";
import { FaSyncAlt } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { resetApp } from "../../store/actions";
import ActionButton from "./ActionButton";
import { abortAll } from "../../utils/abortController";
import { abortAllLoaders } from "../../store/actions";
const ResetButton = () => {
  const dispatch = useDispatch();

  function reset() {
    console.clear();
    dispatch(abortAllLoaders());
    abortAll();  // 🧨 immediately stop all pending operations
    dispatch(resetApp());
    sessionStorage.clear();
  }

  return <ActionButton icon={FaSyncAlt} tooltip="Refresh" onClick={reset} />;
};

export default ResetButton;
